import {
  fetchFiles,
  fetchFolders,
  fetchItemsCount,
  fetchItemsWithFlow,
  fetchUsers,
  getItemsFromCollection,
  getNotificationsFromDirectus,
} from "directus/src/operations";

export function getFetchFunctions(endpoint, flowId) {
  switch (endpoint) {
    case "notifications":
      return {
        fetchFn: async (_, query) => getNotificationsFromDirectus(query),
        countFn: async (_, query) =>
          getNotificationsFromDirectus({
            aggregate: { countDistinct: ["id"] },
            filter: query?.query?.filter || {},
          }),
      };
    case "users":
      return {
        fetchFn: async (_, query) => fetchUsers(query),
        countFn: async (_, query) =>
          fetchUsers({
            aggregate: { countDistinct: ["id"] },
            filter: query?.query?.filter || {},
            search: query?.query?.search || "",
          }),
      };
    case "files":
      return {
        fetchFn: async (_, query) => fetchFiles(query),
        countFn: async (_, query) =>
          fetchFiles({
            aggregate: { countDistinct: ["id"] },
            filter: query?.query?.filter || {},
          }),
      };
    case "folders":
      return {
        fetchFn: async (_, query) => fetchFolders(query),
        countFn: async (_, query) =>
          fetchFolders({
            aggregate: { countDistinct: ["id"] },
            filter: query?.query?.filter || {},
          }),
      };
    case "flow":
      return {
        fetchFn: async (_, query) => {
          return fetchItemsWithFlow(flowId, query.filter);
        },
      };
    default:
      return {
        fetchFn: getItemsFromCollection,
        countFn: fetchItemsCount,
      };
  }
}
